@if (loading) {
  <div class="as-fixed-loader">
    <ng-lottie width="150px" height="150px" [options]="options"> </ng-lottie>
    <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
      {{ loadingText }}...
    </mat-label>
  </div>
}
<main>
  <div
    class="as-row as-close as-space-icons"
    [ngClass]="step === 0 ? 'as-justify-end' : 'as-justify-sb'"
    >
    @if (step === 1 || step === 2) {
      <mat-icon
        svgIcon="ic-back-green"
        class="as-pointer"
        (click)="step === 1 ? goBackSelectAddress() : (step = 1)"
      ></mat-icon>
    }
    <mat-icon
      svgIcon="ic-close-green"
      class="as-pointer"
      mat-dialog-close
    ></mat-icon>
  </div>
  @switch (step) {
    @case (0) {
      <div class="as-select-address">
        <div class="data">
          <div class="texts">
            <p class="as-font-18 as-font-bold">
              {{ 'ADDRESSES.CREATE.recieveOrder' | translate }}
            </p>
            <p>
              {{ 'ADDRESSES.CREATE.pls' | translate }}
            </p>
          </div>
          <app-address-autocomplete
            [injectAddress]="address"
            [setTextToInput]="false"
            [inputText]="'Escribe la dirección de entrega'"
            (setAddress)="saveAddress($event)"
            adressType="geocode"
            >
          </app-address-autocomplete>
        </div>
        <div
          (click)="requestLocationPermissions()"
          class="location as-pointer as-row as-align-center as-justify-center"
          >
          <p class="as-font-14 as-font">
            {{ 'ADDRESSES.CREATE.currentLocation' | translate }}
          </p>
        </div>
      </div>
    }
    @case (1) {
      <div class="as-map">
        <mat-label class="as-roboto-slab as-font-bold as-font-24">
          {{ 'ADDRESSES.CREATE.verify' | translate }}
        </mat-label>
        @if (!data.currentLocation) {
          <div class="as-address-details">
            <div class="as-icon-container">
              <mat-icon class="as-pin-red" svgIcon="ic-pin-red"></mat-icon>
            </div>
            <p class="details">
              <span>
                {{ referenceAddress }}
              </span>
              <mat-icon
                (click)="goBackSelectAddress()"
                class="as-pointer"
                svgIcon="ic-edit"
              ></mat-icon>
            </p>
          </div>
        }
        <google-map [center]="centerPosition" [zoom]="17">
          <map-marker
            (mapDragend)="moveMap($event)"
            [position]="marker?.position"
            [options]="marker?.options"
            >
          </map-marker>
        </google-map>
        <button
          mat-flat-button
          color="accent"
          class="as-confirm-button"
          (click)="goStep(2)"
          >
          <mat-label class="as-font-14 as-font-semibold as-font-white">
            {{ 'GENERAL.confirm' | translate }}
          </mat-label>
        </button>
      </div>
    }
    @case (2) {
      <div class="as-map">
        <form
          autocomplete="off"
          class="as-add-address-container"
          [formGroup]="addressForm"
          >
          <mat-label class="as-roboto-slab as-font-bold as-font-24">
            {{ 'ADDRESSES.CREATE.confirm' | translate }}
          </mat-label>
          <mat-dialog-content>
            <br />
            <mat-form-field color="accent" class="as-font">
              <mat-label>
                {{ 'ADDRESSES.CREATE.address' | translate }}
              </mat-label>
              <input matInput formControlName="detail" />
              @if (
                addressForm.get('detail')?.value !== '' &&
                addressForm.get('detail')?.value !== null
                ) {
                <button
                  mat-icon-button
                  matSuffix
                  type="button"
                  (click)="changeDirection()"
                  >
                  <mat-icon svgIcon="ic-close-green"></mat-icon>
                </button>
              }
              <mat-hint class="as-font as-font-12 as-font-green"
                >*{{ 'ADDRESSES.CREATE.confirm1' | translate }}</mat-hint
                >
              </mat-form-field>
              <br />
              <mat-form-field color="accent" class="as-font">
                <mat-label> {{ 'ADDRESSES.references' | translate }} </mat-label>
                <input matInput formControlName="references" />
              </mat-form-field>
              <mat-label class="as-font-bold">
                {{ 'ADDRESSES.setAddress' | translate }}
              </mat-label>
              <br /><br />
              <div class="as-addresses-type-row">
                @for (tag of tagButtonsList; track tag) {
                  <button
                    mat-button
                    type="button"
                    class="as-address-type-button"
              [class.as-address-type-selected]="
                addressTypeSelected === tag.name
              "
                    (click)="selectAddressType(tag.name)"
                    >
                    <div class="as-column as-align-center">
                      <mat-icon svgIcon="{{ tag.icon }}"></mat-icon>
                      <mat-label class="as-font as-font-10 as-line-height-normal">
                        {{ tag.label | translate }}
                      </mat-label>
                    </div>
                  </button>
                }
              </div>
              <br />
              <div class="as-default-address">
                <mat-checkbox formControlName="default"></mat-checkbox>
                <mat-label class="as-font as-font-12">
                  {{ 'ADDRESSES.defaultAddress' | translate }}
                </mat-label>
              </div>
            </mat-dialog-content>
            <button
              mat-flat-button
              color="accent"
              class="as-continue-button"
              (click)="onCreateAddress()"
              [disabled]="addressForm.invalid"
              >
              <mat-label class="as-font-14 as-font-semibold as-font-white">
                {{ 'GENERAL.continue' | translate }}
              </mat-label>
            </button>
          </form>
        </div>
      }
    }
  </main>
